const data = {
  translation: {
    lbl_welcome: "Bienvenue à",
    lbl_hodo_community_events: "Événements communautaires HODO",
    lbl_setup_sound_and_video:
      "Installer l'équipement audio et vidéo avant de participer",
    lbl_join_room: "Join room",
    lbl_join_conference: "Join conference",
    lbl_enter_name: "Enter my name",
    lbl_on: "On",
    lbl_off: "Off",
    lbl_change_camera: "Toggle front or back Camera",
    lbl_add_virtual_background: "Add virtual background",
    lbl_vietnamese: "Vietnamese",
    lbl_english: "English",
    lbl_french: "French",
    lbl_setting_device: "Réglages de l'appareil",
    lbl_notification: "Notification",
    lbl_view_layout: "Vue Mise en page",
    lbl_audio_device: "Équipements audio",
    lbl_speaker: "Speaker",
    lbl_test: "Test",
    lbl_noise_suppression: "Suppression de bruit",
    lbl_participants: "Les participants",
    lbl_the_leaver: "Le partant",
    lbl_new_message: "Nouveau message",
    lbl_hand_raiser: "Leveur de main",
    lbl_error: "Erreur",
    lbl_active_speaker_mode: "Mode haut-parleur en cours",
    lbl_arranging_active_speakers: "Disposition des haut-parleurs actifs",
    lbl_audio_only_mode: "Mode audio uniquement",
    lbl_personal_video_mirror: "Miroir vidéo personnel",
    lbl_personal_video_hidden: "Vidéo personnelle cachée",
    lbl_error_check_role:
      "Erreur lors de la vérification des rôles d'utilisateur",
    lbl_meting: "Réunion",
    lbl_room_code_is_disabled: "Room code is disabled",
    lbl_room_code_does_not_exist: "Room code does not exist",
    lbl_endpoint_is_not_reachable: "Endpoint is not reachable",
    lbl_room_does_not_exist: "Room does not exist",
    lbl_accessing_disabled: "Accessing room using this link format is disabled",
    lbl_error_fetching_token: "Error fetching token",
    lbl_deactivate: "Désactiver",
    fm_toggle_interpretation: "Choisissez d'écouter l'interprétation",
    lbl_other_options: "Un autre choix",
    lbl_setting: "Paramètre",
    lbl_you: "Toi",
    lbl_have_a_nice_day: "Passe une bonne journée",
    lbl_join_again: "Vous souhaitez nous rejoindre à nouveau",
    lbl_click_here: "Cliquez ici",
    lbl_stream: "stream",
    lbl_room: "room",
    lbl_rename: "Rename",
    lbl_change_role: "Change role",
    lbl_change_my_role: "Change my role",
    lbl_mute_all: "Mute all",
    lbl_exit: "Exit",
    lbl_url_embed: "URL embed",
    lbl_cancel: "Cancel",
    lbl_change: "Change",
    lbl_update_embed: "Update embed",
    lbl_stop_embed: "Stop embed",
    lbl_embed_and_share: "Embed and share",
    lbl_change_multiple_role: "Change multiple role",
    lbl_select_role: "Select role",
    lbl_select_multiple_role: "Select multiple role",
    lbl_become_role: "Become role:",
    lbl_my_screen: "My screen",
    lbl_signal: "Poor signal",
    lbl_mute_mic: "You're muted",
    lbl_participants_1: "Participants",
    lbl_no_participants: "There are no participants",
    lbl_no_suitable_participants: "Il n'y a pas de participants appropriés",
    lbl_input_search: "Input search information",
    lbl_all: "All",
    lbl_change_permissions: "Change permissions",
    lbl_remove_participants: "Remove participants",
    lbl_change_role_of: "Change role of",
    lbl_become: "become",
    lbl_submit_request_confirm: "Send confirmation request",
    lbl_pin: "Pin",
    lbl_unpin: "Unpin",
    lbl_outstanding_position_for_everyone: "Outstanding position for everyone",
    lbl_removed_from_prominent_position: "Removed from prominent position",
    lbl_connected_now: "You are now connected",
    lbl_open_chat: "Open chat",
    lbl_welcome_joined: "Welcome, you've joined",
    lbl_person_first: "You are the first person to join the room",
    lbl_sit_down: "Please sit back and relax until others join",
    lbl_select_maximum_resolution: "Select maximum resolution",
    lbl_currently_streaming: "Currently streaming:",
    lbl_low: "Low",
    lbl_high: "Medium",
    lbl_medium: "High",
    lbl_sharing_screen: "You are sharing your screen",
    lbl_stop_share: "Stop sharing your screen",

    msg_error_check_role:
      "An error occurred while checking your role. Please double check your role or contact Circle's Seed for more details.",
    msg_room_code_is_disabled:
      "Room code corresponding to this link is no more active.",
    msg_room_code_does_not_exist:
      "We could not find a room code corresponding to this link.",
    msg_room_does_not_exist:
      "We could not find a room corresponding to this link.",
    msg_accessing_disabled:
      "You can re-enable this from the developer section in Dashboard.",
    msg_error_fetching_token:
      "An error occurred while fetching the app token. Please look into logs for more details.",
    msg_embed:
      "Embed the url and share with everyone in the room. Make sure you're sharing the current tab when the prompt opens. Note that not all websites support embedding.",

    fm_toggle_sound: "{{status}} mic ({{key}} + d)",
    fm_toggle_video: "{{status}} video ({{key}} + e)",
    fm_toggle_background: "{{status}} virtual background",
    fm_gird_layout_view: "Grille en vue({{count}})",
    fm_toggle_pip: "{{status}} mode image-dans-l'image",
    fm_interpretation_end:
      "La traduction de {{text1}} est terminée. Vous êtes redirigé pour écouter {{text2}}",
    fm_interpretation_select: "Vous avez choisi d'écouter {{text}}",
    fm_you_have_left_cabin: "Vous avez quitté la salle des épidémies",
    fm_not_connect_room: "Can't connect to {{name}}",
    fm_endpoint_is_not_reachable: "Endpoint is not reachable. {{desc}}",
    fm_you_out_room: "You have left the room {{name}}",
    fm_fullscreen: "{{action}} fullscreen",
    fm_open_chat: "{{action}} chat",
    fm_you_content: "Toi ({{content}})",
    fm_toggle_fullscreen: "{{text}} plein écran",
    fm_toggle_sharescreen: "{{text}} je t'en prie",
    fm_volume: "Volume {{number}}",
    fm_pin_screen: "{{action}} frame",
    fm_block_permission: "Permission {{device}} has been blocked",
    fm_access_permission: "Access to {{device}} is required. ",
    fm_accept_permission_system:
      "Enable {{device}} permissions from the system",
    fm_accept_permission_browser:
      "Enable {{device}} permissions from the address bar or browser settings",
    fm_hands_up: "{{name}} hands up",
    fm_hands_up_multiple:
      "{{name}} and {{number}} other person raised their hands",
    fm_joined: "{{name}} joined",
    fm_joined_multiple: "{{name}} and {{number}} other person joined",
    fm_left: "{{name}} left",
    fm_left_multiple: "{{name}} and {{number}} other person left",
    fm_new_message: "New message from {{name}}",
    fm_new_message_multiple: "{{number}} new message",
    fm_offline:
      "You are now online, while we try to reconnect, please check your internet connection. {{message}}",

    fm_start: "Commencer",
    fm_stop: "Arrêt",
    lbl_no_msg: "Pas de messages",
    lbl_hands_up: "Les mains en l'air",
    lbl_hands_down: "Les doigts dans le nez",
    lbl_open: "Ouvrir en",
    lbl_close: "Fermer le",
    lbl_activate: "Activer",
    lbl_everyone: "Tout le monde",
    lbl_new_msgs: "Nouveaux messages",
    lbl_find_participants: "Trouver des participants",
    lbl_roles: "Les rôles",
    lbl_participant: "Participants",
    lbl_write_smt_here: "Écrivez quelque chose ici",
    lbl_toggle_all_remote_audio_devices:
      "Couper/Réactiver le son des appareils audio distants",
    lbl_all_roles: "Tous les rôles",
    lbl_track_type: "Type de piste",
    lbl_track_source: "Source de la piste",
    lbl_track_status: "État du suivi",
    lbl_mute: "Muet",
    lbl_unmute: "Demande de réactiver le son",
    lbl_apply: "Appliquer",
    lbl_all_sources: "Toutes les sources",
    lbl_all_devices: "À nouveau tous les appareils",
    lbl_strangers: "Étranger",
    lbl_pin_msg: "Épingler le message",

    obj_roles: {
      lbl_presenter: "Présentateur",
      lbl_broadcaster: "Haut-parleur",
      lbl_panelist: "Panéliste",
      lbl_translator: "Interprète",
      "lbl_e-v": "Anglais - Vietnamien",
      "lbl_f-v": "Français - Vietnamien",
      lbl_vietnamese: "Vietnamienne",
      lbl_guest: "Invité",
      "lbl_guest-advanced": "Invité (avancé)",
      lbl_viewer: "Téléspectateur",
      "lbl_hls-viewer": "Téléspectateur",
    },
    lbl_waiting_for_the_live_stream_to_start:
      "En attendant le début du livestream",
    lbl_live_streaming: "Diffusion en direct",
    lbl_stream_management: "Gestion des stream",
    lbl_stop_recording: "Arrête d'enregistrer",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Etes-vous sûr de vouloir mettre fin à l'enregistrement ?",
    lbl_stop: "Arrêt",
    lbl_starting_recording: "Démarrage de l'enregistrement",
    lbl_start_recording: "Commencer l'enregistrement",
    lbl_start: "Commencer",
    lbl_recording_already_running: "Enregistrement déjà en cours",
    lbl_browser_message:
      'Le navigateur souhaite que nous obtenions une confirmation pour jouer au Live HODO. Veuillez cliquer sur "lire le stream" pour continuer.',
    lbl_select_quality: "Sélectionnez la qualité",
    lbl_auto: "Auto",
    lbl_play: "Play",
    lbl_pause: "Pause",
    lbl_the_conference_will_start_in: "La conférence commencera dans",
    lbl_the_conference_will_begin_soon:
      "La conférence va bientôt commencer. \nVeuillez vous asseoir, vous reposer et vous détendre pendant le temps d'attente.",
    lbl_the_conference_has_ended:
      "La conférence est terminée, veuillez revenir à un autre moment. \nMerci !",
    lbl_you_can_connect_with_others:
      "Vous ne pouvez pas vous connecter avec les autres.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "Vous êtes connecté mais personne n'est actif dans le cercle.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Actuellement, il n'y a personne d'autre dans la pièce.",
    lbl_this_role_does_not_exist: "Ce rôle n'existe pas.",
    lbl_this_role_has_not_been_published: "Ce rôle n'a pas été publié.",
  },
};

export default data;
